import { tokensToStyle } from "@/lib/themes";

// Applies theme tokens as scoped CSS variables to a wrapper div.
export default function ThemeScope({ tokens, className = "", children, style = {} }) {
  return (
    <div
      className={`bg-background text-foreground font-body ${className}`}
      style={{ ...tokensToStyle(tokens), ...style }}
    >
      {children}
    </div>
  );
}
